import { z } from 'zod'

/**
 * A feature a company can have switched on or off by a super admin. Mirrors the
 * `TenantFeature` enum in the Prisma schema — the two must stay in sync
 * (`check:enums`). What each one is called, and what a company without it sees,
 * lives in `lib/src/constants/tenant-features.ts`.
 */
export const TENANT_FEATURES = ['marketing', 'gohighlevel', 'ads', 'honeybook'] as const

export const tenantFeatureSchema = z.enum(TENANT_FEATURES)

export type TenantFeature = z.infer<typeof tenantFeatureSchema>
